import { Form } from '@valid-eval/shared-react-components';
import { FormProvider } from 'react-hook-form';
import type { FieldValues, SubmitHandler, UseFormReturn } from 'react-hook-form';

type EditEventStepFormProps<T extends FieldValues> = {
  methods?: UseFormReturn<T, T, T>;
  onSubmit?: SubmitHandler<T>;
  label: string;
  subLabel: string;
  children: React.ReactNode;
};

function EditEventStepForm<T extends FieldValues>({
  methods,
  onSubmit,
  label,
  subLabel,
  children,
}: EditEventStepFormProps<T>) {
  const content = (
    <div className="p-3 flex-grow-1 pb-5 mb-3">
      <h1 className="m-0">{label}</h1>
      <small className="text-muted">{subLabel}</small>
      {children}
    </div>
  );

  if (!methods || !onSubmit) {
    return <div className="h-100 d-flex flex-column">{content}</div>;
  }

  return (
    <FormProvider {...methods}>
      <Form className="h-100 d-flex flex-column" onSubmit={methods.handleSubmit(onSubmit)}>
        {content}
      </Form>
    </FormProvider>
  );
}

export default EditEventStepForm;
